// Sorts applied filters array by CanonicalOrder number to ensure its represented in same order as breadcrumbs
const appliedFiltersSortingCallback = ({ CanonicalOrder: orderA }, { CanonicalOrder: orderB }) => orderA - orderB;

export default appliedFiltersSortingCallback;
